const labelTypes = {
  withoutGoogle: 0,
  system: 'system',
  user: 'user'
}

export const INBOX = 'INBOX'
export const SENT = 'SENT'
export const DRAFT = 'DRAFT'
export const TRASH = 'TRASH'

const sidebarTabs = [
  {
    id: INBOX,
    title: 'Inbox',
    threadsUnread: 0,
    threadsTotal: 1,
    type: labelTypes.system,
    icon: 'tab-inbox'
  },
  {
    id: SENT,
    title: 'Sent',
    threadsUnread: 0,
    threadsTotal: 0,
    type: labelTypes.system,
    icon: 'tab-sent'
  },
  {
    id: DRAFT,
    title: 'Draft',
    threadsUnread: 0,
    threadsTotal: 1,
    type: labelTypes.system,
    icon: 'tab-draft'
  },
  {
    id: 'Saved (Business Boutique Group)',
    systemId: 'SAVED',
    title: 'To-do',
    threadsUnread: 0,
    threadsTotal: 1,
    type: labelTypes.user,
    icon: 'tab-todo',
    labelName: 'Saved (Business Boutique Group)'
  },
  {
    id: 'TEMPLATES',
    title: 'Templates',
    type: labelTypes.withoutGoogle,
    icon: 'tab-templates'
  },
  {
    id: 'To-do (Business Boutique Group)',
    systemId: 'TODO',
    title: 'Control',
    threadsUnread: 0,
    threadsTotal: 1,
    type: labelTypes.user,
    icon: 'tab-control',
    labelName: 'To-do (Business Boutique Group)'
  },
  {
    id: TRASH,
    title: 'Trash',
    threadsUnread: 0,
    threadsTotal: 0,
    type: labelTypes.system,
    icon: 'tab-trash'
  }
]

export {sidebarTabs, labelTypes}



// WEBPACK FOOTER //
// ./src/constants/sidebarTabs.js